// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"2900":"0b661f96","7828":"bf835c4f","8780":"fe2e56a0","9678":"07f7ef09"}[chunkId] + ".chunk.js";
};